import { FlexBox, Icon, Typography } from '@vp/swan';
import React from 'react';
import './TypingIndicator.styles.scss';
import { isMobile } from '../../utils/mobile-utils';
import { getBrowserName } from '../../utils/app-utils';

export interface ITypingIndicatorProps {
  senderType: 'agent' | 'chatbot';
}
const TypingIndicator: React.FC<ITypingIndicatorProps> = ({ senderType }) => {
  if (senderType === 'chatbot') {
    return (
      <FlexBox>
        <Icon iconType="aiSupport" size="20p" />
        <Typography
          fontSize="small"
          textColor="subtle"
          paddingLeft={6}
          className="chatbot-typing-text"
          mb={isMobile() && getBrowserName() === 'Safari' ? 6 : undefined}
        >
          Vista Assistant thinking...
        </Typography>
      </FlexBox>
    );
  }
  return (
    <>
      <svg height="20" viewBox="0 0 40 20" xmlns="http://www.w3.org/2000/svg">
        <circle className="dot" cx="5" cy="10" r="4" fill="#555" />
        <circle className="dot" cx="20" cy="10" r="4" fill="#555" />
        <circle className="dot" cx="35" cy="10" r="4" fill="#555" />
      </svg>
    </>
  );
};
export default TypingIndicator;
